import Commitment from '../../../assets/images/aboutuspage/commitment.webp'
import { motion, AnimatePresence } from 'framer-motion'
import { useEffect, useState } from 'react'

const DOT_GROUPS = {
  topClaspZone: [
    { x: 44.5, y: 34.5 },
    { x: 51, y: 32.5 },
    { x: 59, y: 30.5 },
  ],

  leftHand: [
    { x: 23, y: 57.5 },
    { x: 23, y: 46.5 },
    { x: 23.5, y: 26.5 },
    { x: 15.5, y: 61.5 },
    { x: 32.5, y: 58.5 },
    { x: 29.5, y: 69.5 },
    { x: 34.5, y: 42.5 },
  ],

  rightHand: [
    { x: 66.5, y: 45.5 },
    { x: 83.5, y: 56.5 },
    { x: 74.5, y: 46.5 },
    { x: 78, y: 35.5 },
  ],

  centerBody: [
    { x: 41.5, y: 51.5 },
    { x: 55.5, y: 46.5 },
    { x: 56, y: 63.5 },
    { x: 71.5, y: 66.5 },
  ],

  bottomEdge: [
    { x: 37.5, y: 73.5 },
    { x: 49.5, y: 79 },
    { x: 50.5, y: 96.5 },
    { x: 63, y: 84 },
  ],
}
const DOT_POSITIONS = Object.entries(DOT_GROUPS).flatMap(([group, dots]) =>
  dots.map((dot) => ({ ...dot, group }))
)

function getRandomGroup(total: number, size: number): number[] {
  return Array.from({ length: total }, (_, i) => i)
    .sort(() => Math.random() - 0.5)
    .slice(0, size)
}

const GuideUs = () => {
  const [activeIndices, setActiveIndices] = useState<number[]>([0, 7, 13])

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndices(getRandomGroup(DOT_POSITIONS.length, 3))
    }, 2000)
    return () => clearInterval(interval)
  }, [])

  return (
    <section className="w-full px-4 sm:px-6 md:px-5 2xl:px-16 mb-10">
      <div className="mx-auto lg:w-[99%] xl:w-[85%]">
        <h2 className="text-center font-rajdhani text-3xl font-semibold text-white sm:text-4xl md:text-5xl">
          Our Commitment
        </h2>

        <div className="mt-8 rounded-[40px] bg-linear-to-br from-[#745EF0] via-[#745EF0]/15 to-transparent p-px md:mt-10">
          <div className="rounded-[40px] bg-[#0b0820]/95 p-5 sm:p-7 md:p-8 lg:p-10">
          <div className="grid items-center lg:grid-cols-[1.1fr_0.9fr] lg:gap-10">

{/* TEXT */}
<motion.div
  className="order-2 lg:order-1 space-y-8  py-4 sm:px-5 sm:py-5"
  initial={{ opacity: 0, x: -90 }}
  whileInView={{ opacity: 1, x: 0 }}
  viewport={{ once: true, amount: 0.7 }}
  transition={{ duration: 2, ease: [0.22, 1, 0.36, 1] }}
>
  <p className="mt-2 font-gilroy text-base leading-relaxed text-gray-400 sm:text-xl">
    We do not take every project that comes our way. We take projects where we can
    genuinely deliver exceptional outcomes, where our expertise in AI automation for
    regulated industries is exactly what is needed. If we are not the right fit, we
    will tell you.
  </p>

  <p className="mt-2 font-gilroy text-base leading-relaxed text-gray-400 sm:text-xl">
    For the clients we do serve, our commitment is simple: we will treat your project
    as if our reputation depends on it, because it does.
  </p>
</motion.div>

{/* IMAGE */}
<div className="order-1 lg:order-2 relative mx-auto flex w-full justify-center overflow-hidden rounded-xl">
  <img
    src={Commitment}
    alt="Commitment handshake"
    className="h-[200px] w-full object-contain sm:h-[200px] md:h-[430px] lg:h-[450px] xl:h-[500px] 2xl:h-[500px]"
  />

  <div className="pointer-events-none absolute inset-0 overflow-hidden">
    {DOT_POSITIONS.map((dot, i) => {
      const isActive = activeIndices.includes(i)

      return (
        <AnimatePresence key={i}>
          {isActive && (
            <motion.div
              className="absolute"
              style={{
                left: `${dot.x}%`,
                top: `${dot.y}%`,
                transform: 'translate(-50%, -50%)',
              }}
              initial={{ opacity: 0, scale: 0.3 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.3 }}
              transition={{ duration: 0.35, ease: 'easeOut' }}
            >
              {/* Ripple ring */}
              <motion.div
                className="absolute rounded-full"
                style={{
                  width: 22,
                  height: 22,
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  background:
                    'radial-gradient(circle, rgba(96,200,255,0.35) 0%, transparent 70%)',
                }}
                animate={{ scale: [1, 1.8, 1], opacity: [0.6, 0, 0.6] }}
                transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
              />

              {/* Core dot */}
              <motion.div
                className="relative rounded-full"
                style={{ width: 6, height: 6, background: '#bfdbfe' }}
                animate={{
                  boxShadow: [
                    '0 0 4px 2px rgba(191,219,254,0.4)',
                    '0 0 12px 4px rgba(191,219,254,1)',
                    '0 0 4px 2px rgba(191,219,254,0.4)',
                  ],
                  scale: [1, 1.3, 1],
                }}
                transition={{ duration: 1.5, repeat: Infinity, ease: 'easeInOut' }}
              />
            </motion.div>
          )}
        </AnimatePresence>
      )
    })}
  </div>
</div>

</div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default GuideUs